import { CUSTOMER_INFORMATIONS_UPDATED, CUSTOMER_INFORMATIONS_READY } from './actions';

export function customerInformationsReducer(state = null, action) {
  switch (action.type) {
    case CUSTOMER_INFORMATIONS_UPDATED:
      return action.informations;
    case CUSTOMER_INFORMATIONS_READY:
      return action.informations;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerInformationService/reducers.js